import { isPlatformBrowser } from '@angular/common';
import type { Location } from '@freelancer/location';
import { getCookieDomain } from '@freelancer/tracking';
import type { CookieOptions } from 'ngx-cookie';

export function cookieOptionsFactory(
  platformId: object,
  location: Location,
): CookieOptions {
  return isPlatformBrowser(platformId)
    ? {
        path: '/',
        // shared with the inline tracking script, which creates the tracking
        // session cookie with the same attributes before the app boots
        domain: getCookieDomain(location.hostname),
        secure: location.protocol === 'https:',
        sameSite: 'lax',
      }
    : {};
}
